import { useTheme } from '../../hooks/useTheme';

import type { NavSection } from './config';
import { NAV_THEMES } from './nav-tokens';
import { sectionRowClass } from './navSectionRowClass';

interface NavSectionInertProps {
  section: NavSection;
  collapsed: boolean;
}

/** A section whose pages we have not built yet: named, so the viewer knows it
 *  is coming, but neither a link nor a control. */
export default function NavSectionInert({ section, collapsed }: NavSectionInertProps) {
  const { theme } = useTheme();
  const t = NAV_THEMES[theme];
  const Icon = section.icon;
  const label = `${section.label} — coming soon`;

  return (
    <div
      className={`${sectionRowClass(collapsed)} cursor-not-allowed`}
      style={{ color: t.faint }}
      // Collapsed there is no text in the row at all — only an aria-hidden
      // glyph — so without this the row is silent to assistive tech.
      role="note"
      aria-label={label}
      title={label}
    >
      <Icon size={18} aria-hidden className="shrink-0" />
      {!collapsed && (
        <>
          <span>{section.label}</span>
          <span
            className="ml-auto rounded-full px-2 py-0.5 text-[9px] font-bold uppercase tracking-wide"
            style={{ background: t.surface, color: t.faint }}
          >
            Soon
          </span>
        </>
      )}
    </div>
  );
}
